import Vue from 'vue';
import Component from 'vue-class-component';
import SidebarComponent from '@/components/sidebar/sidebar.component.vue';
import HeaderComponent from '@/components/header/header.component.vue';
import LoaderComponent from '@/components/loader/loader.component.vue';
import ModalPermissionsComponent from '@/components/modal-permissions/modal-permissions.component.vue';
import ModalLoginComponent from '@/components/modal-login/modal-login.component.vue';
//service
import DetailService from '@/core/services/detail.service.ts';
import SidebarService from '@/core/services/sidebar.service.ts';

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent,
    LoaderComponent
  }
})
export default class BusinessDetailComponent extends Vue {

  detailService: any = new DetailService();
  sidebarService: any = new SidebarService();
  business_id: any = [];
  isLoading: boolean = false;
  logInModal: boolean = false;
  showModal: boolean = false;
  isSuccess: boolean = false;
  isErrorServer: boolean = false;
  name: string = "";
  createdAt: string = "";
  updatedAt: string = "";

  mounted (){
    const _ = this;
    _.getByBusiness();
    _.filterDate();
  }

  closeSidebar(){
    const _ = this;
    _.sidebarService.close();
  }

  filterDate(date: any = ''){
    const _ = this;
    date = date.split("T");
    date = date[0];
    return date;
  }

  getByBusiness(){
    const _ = this;
    _.business_id = location.href.split("/");
    _.business_id = _.business_id[5];
    _.isLoading = true;
    _.detailService.getByBusiness(_.business_id).then((data: any) => {
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
      _.name = data["data"].business.name;
      _.createdAt = data["data"].business.createdAt;
      _.updatedAt = data["data"].business.updatedAt;
    })
    .catch((err: any) => {
      if(err.response.data.message.includes('Invalid or inexistent user')){
        localStorage.removeItem('tk_auth');
        _.logInModal = true;
      }
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
  }
}
